module.exports = __webpack_public_path__ + "static/media/expressiveBubbleGum-small.31e7cf2b.jpg";